import { pathOr, sortBy, prop } from 'ramda';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { OldTable } from '@frontend/legacy-components';

import {
  QUOTE_ITEM_STATUS_COLOR,
  QUOTE_ITEM_STATUS_LABEL,
  WORKFLOW_STEP_STATUS_COLORS,
  WORKFLOW_STEP_STATUS_LABEL,
  WORKFLOW_STEP_STATUS,
} from 'constants/all';

import { getDenormalizedQuoteItems } from 'store/quotes/selectors';

import QuoteItem from './QuoteItem';
import { getIsLoading, getQuoteWorkflowSteps } from './data/reducer';

const QuoteItemStatusLabel = styled.p`
  font-weight: 600;
  margin: 0 auto;

  ${(props) => `color: ${QUOTE_ITEM_STATUS_COLOR[props.status]}`}
`;

const WorkflowStepStatusLabel = styled.p`
  font-weight: 600;
  margin: 0 auto;

  ${(props) => `color: ${WORKFLOW_STEP_STATUS_COLORS[props.status]}`}
`;

const QuoteItemStatus = (status) => {
  return (
    <QuoteItemStatusLabel status={status}>
      {QUOTE_ITEM_STATUS_LABEL[status]}
    </QuoteItemStatusLabel>
  );
};

const WorkflowStepStatus = (status = WORKFLOW_STEP_STATUS.NOT_STARTED) => {
  return (
    <WorkflowStepStatusLabel status={status}>
      {WORKFLOW_STEP_STATUS_LABEL[status]}
    </WorkflowStepStatusLabel>
  );
};

const quoteItemColumn = {
  dataIndex: 'id',
  fixed: 'left',
  key: 'id',
  render: QuoteItem,
  title: 'Quote Item',
};

const quoteItemStatusColumn = {
  dataIndex: 'workflowStatus',
  key: 'workflowStatus',
  render: QuoteItemStatus,
  title: 'Status',
};

const sortByPosition = sortBy(prop('position'));

const connector = connect((state) => ({
  isLoading: getIsLoading(state),
  quoteItems: getDenormalizedQuoteItems(state),
  quoteWorkflowSteps: getQuoteWorkflowSteps(state),
}));

const QuoteItemTable = ({ isLoading, quoteItems, quoteWorkflowSteps }) => {
  const columns = [quoteItemColumn, quoteItemStatusColumn];

  sortByPosition(quoteWorkflowSteps).map((step) => {
    columns.push({
      title: pathOr('--', ['step', 'name'], step),
      key: pathOr('--', ['step', 'name'], step),
      dataIndex: [
        'workflowSteps',
        pathOr('', ['step', 'locator'], step),
        'status',
      ],
      render: WorkflowStepStatus,
    });
  });

  return (
    <OldTable
      loading={isLoading}
      emptyOptions={{
        emptyLabel: 'No quote items',
      }}
      rowKey="id"
      columns={columns}
      data={quoteItems}
      size="small"
    />
  );
};

export default connector(QuoteItemTable);
